import React, { FC, useContext } from "react";
import { ThemeContext } from "styled-components";
import { InternalLink } from "@pepdirect/v3/ui/InternalLink";
import {
  Styled404,
  StyledHeadingH1,
  StyledHeadingH2,
  StyledLinks,
  StyledWrapper,
} from "./index.styled";

interface LoyaltyPageErrorProps {
  fallbackUrl: string;
}

export const LoyaltyPageError: FC<LoyaltyPageErrorProps> = ({
  fallbackUrl,
}) => {
  const theme = useContext(ThemeContext);

  return (
    <StyledWrapper>
      <Styled404>
        <StyledHeadingH1 level="h1" size="xl">
          Sorry, there is an issue with your cart.
        </StyledHeadingH1>
        <StyledHeadingH2 level="h2" size="m">
          {`The loyalty reward you’ve selected is a greater value than the ` +
            `items in your cart. Please add more to your cart (or remove the ` +
            `loyalty reward) before continuing.`}
        </StyledHeadingH2>
        <StyledLinks>
          <InternalLink href={`${fallbackUrl}`} color={theme.color.primary}>
            Return to the shop
          </InternalLink>
        </StyledLinks>
      </Styled404>
    </StyledWrapper>
  );
};
